import { render, staticRenderFns } from "./textEditor.vue?vue&type=template&id=700b8a12&scoped=true&"
import script from "./textEditor.vue?vue&type=script&lang=js&"
export * from "./textEditor.vue?vue&type=script&lang=js&"
import style0 from "./textEditor.vue?vue&type=style&index=0&id=700b8a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b8a12",
  null
  
)

export default component.exports